import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { IconButton } from "@mui/material";

const StyledMobileHeader = styled("div")`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.customGrey.soft};
  height: max-content;

  @media (min-width: 1024px) {
    display: none;
    visibility: visible;
  }
`;

const StyledMobileHeaderLogo = styled(Link)`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  height: 50px;

  & > svg {
    width: 100%;
  }
`;

const StyledMobileHeaderBurgerBtn = styled(IconButton)`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.primary.main};

  & svg {
    width: 100%;
    transition: all 0.2s linear;
  }

  & svg[stroke] {
    stroke: ${({ theme }) => theme.palette.primary.dark};
  }

  &:hover {
    & svg[stroke] {
      stroke: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

export {
  StyledMobileHeader,
  StyledMobileHeaderLogo,
  StyledMobileHeaderBurgerBtn,
};
